module.exports = __webpack_public_path__ + "static/media/chart-adding-another-v2.7483fa51.svg";